// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Pages
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import AdminAnalytics from './pages/AdminAnalytics';
import OnboardingExisting from './pages/OnboardingExisting';
import OnboardingNew from './pages/OnboardingNew';
import SubAccountConsent from './pages/SubAccountConsent';
import SubAccountRequest from './pages/SubAccountRequest';

import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';

// ProtectedRoute component
import ProtectedRoute from './components/ProtectedRoute'; 

import './App.css'; // Keep your CSS import if you want to use it.

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin routes */}
        <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/analytics" 
          element={
            <ProtectedRoute>
              <AdminAnalytics />
            </ProtectedRoute>
          } 
        />
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Form routes */}
        <Route path="/onboarding/existing" element={<OnboardingExisting />} />
        <Route path="/onboarding/new" element={<OnboardingNew />} />
        <Route path="/subaccount/request" element={<SubAccountRequest />} />
        <Route path="/subaccount/consent" element={<SubAccountConsent />} />

        {/* NEW: Terms & Privacy Policy routes */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* 
          Optional home route if you have a home or landing page:
          <Route path="/" element={<HomePage />} />
        */}

        {/* 
          You can also add a fallback for unmatched routes:
          <Route path="*" element={<NotFoundPage />} />
        */}
      </Routes>
    </Router>
  );
}

export default App;
